import { render } from "./DApp .vue?vue&type=template&id=a6aa8bca&scoped=true"
import script from "./DApp .vue?vue&type=script&lang=js"
export * from "./DApp .vue?vue&type=script&lang=js"

import "./DApp .vue?vue&type=style&index=0&id=a6aa8bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6aa8bca"]])

export default __exports__